/**
 * Map Embed modal controller.
 *
 * This class controls the Welcome Office theme's Map Embed modal.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class MapEmbed
 */
 class MapEmbed {

	/**
     * Class constructor is for binding class properties.
     */
	constructor() {
	}

	/**
	 * Cache dom elements for use in the class's methods
	 */
	cache() {

		this.mapEmbedBtns = document.querySelectorAll( '.map-embed > .btn' );
	}

	/**
     * All common events
     * @return {void}
     */
	events() {

		if ( this.mapEmbedBtns.length ) {

			this.mapEmbedBtns.forEach( ( mapBtn ) => {

				mapBtn.addEventListener( 'click', function( e ) {
					Theme.Common.stop( e );

					this.style.display = 'none'; // Hide the button itself
					this.previousElementSibling.style.display = 'block'; // Reveal iframe, covering the container's background image
					this.previousElementSibling.focus();  // Focus the map iframe
				});
			});
		}
	}

	/**
     * Run when the document is ready.
     */
	docReady() {
		this.cache();
		this.events();
	}
}

// Export the class reference.
module.exports = new MapEmbed();



// WEBPACK FOOTER //
// ./assets/scripts/map-embed.js